'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // import { addTask } from '../actions'


var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var folders = function folders() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  var file = void 0,
      files = void 0,
      folders = void 0,
      folder = void 0,
      openFolders = void 0,
      folder_id = void 0,
      filesAreLoaded = void 0;
  switch (action.type) {
    case 'LOAD_FOLDERS':
      return _extends({}, state, {
        folders: action.folders
      });

    case 'LOAD_FILES':
      if (!action.files.length) {
        return state;
      }
      folder_id = action.files[0].folder_id;
      folders = state.folders.map(function (folder) {
        if (folder.id === folder_id) {
          folder.files = action.files;
        }
        return folder;
      });
      return _extends({}, state, {
        folders: folders
      });

    case 'ADD_FOLDER':
      folders = [action.folder].concat(state.folders);
      return _extends({}, state, {
        folders: folders
      });

    case 'LOAD_OPEN_FOLDERS':
      return _extends({}, state, {
        openFolders: action.folders
      });

    case 'OPEN_FOLDER':
      openFolders = state.openFolders;
      folder = action.folder;
      folder_id = folder.id;
      if (openFolders.indexOf(folder.id) === -1) {
        openFolders = [folder.id].concat(openFolders || []);
        localStorage['openFolders'] = JSON.stringify(openFolders);
      }
      filesAreLoaded = state.folders.some(function (folder) {
        if (folder.id === folder_id && folder.files) {
          return true;
        }
        return false;
      });
      if (!filesAreLoaded) {
        _client2.default.file.index({ folder_id: folder_id }).then(function (files) {
          action.cb && action.cb(files);
        });
      }
      return _extends({}, state, {
        openFolders: openFolders
      });

    case 'CLOSE_FOLDER':
      folder = action.folder;
      openFolders = state.openFolders.filter(function (folder_id) {
        return folder_id !== folder.id;
      });
      localStorage['openFolders'] = JSON.stringify(openFolders);

      return _extends({}, state, {
        openFolders: openFolders
      });

    case 'ADD_FILES':
      files = action.files;
      folder_id = Number(files[0] && files[0].folder_id);
      folders = state.folders.map(function (folder) {
        if (folder.id === folder_id) {
          folder.files = (folder.files || []).concat(files);
          return Object.assign({}, folder);
        } else {
          return folder;
        }
      });

      return _extends({}, state, {
        folders: folders
      });

    case 'ADD_FILE':
      file = action.file;
      folders = state.folders.map(function (folder) {
        if (folder.id === file.folder_id) {
          folder.files = folder.files || [];
          folder.files.push(file);
          return Object.assign({}, folder);
        } else {
          return folder;
        }
      });

      return _extends({}, state, {
        folders: folders
      });

    case 'UPDATE_FILE':
      file = action.file;
      folders = state.folders.map(function (folder) {
        if (folder.id === file.folder_id && folder.files) {
          folder.files = folder.files.map(function (f) {
            return f.id == file.id ? file : f;
          });
          return Object.assign({}, folder);
        } else {
          return folder;
        }
      });

      return _extends({}, state, {
        folders: folders
      });

    default:
      return state;
  }
};

exports.default = folders;


//////////////////
// WEBPACK FOOTER
// ./client/reducers/folders.js
// module id = 117
// module chunks = 0